import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";

import theme from "./theme";
import Header from "./components/Header";
import CalcContainer from "./components/CalcContainer";
import Footer from "./components/Footer";
import Example from "./components/Example";
import Grade from "./components/Grade";

function App({ Component }) {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <ChakraProvider theme={theme}>
              <Box className="App">
                <Flex
                  minH="100vh"
                  flexDir="column"
                  justifyContent="space-between"
                  bg="gray.50"
                >
                  <Box>
                    <Header />
                    <CalcContainer />

                    <Example />
                  </Box>
                  <Footer />
                </Flex>
              </Box>
            </ChakraProvider>
          }
        />
        <Route
          path="/dun"
          element={
            <ChakraProvider theme={theme}>
              <Box className="App">
                <Flex
                  minH="100vh"
                  flexDir="column"
                  justifyContent="space-between"
                >
                  <Box>
                    <Header />
                    <Grade />
                  </Box>
                  <Footer />
                </Flex>
              </Box>
            </ChakraProvider>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
